<template>
  <div>
    <span id="landing_title_app_name" :class="$tt('headline1')">Skyline<sup><small> 2.0</small></sup></span>
    <p :class="$tt('button')">WORLD WIDE 3D TERRAIN ON YOUR HOME WALLPAPER</p>
    <ui-button class="big-round-corner-button" v-on:click="openLandingVideoDialog" v-shadow.transition="[1, 4]" outlined icon="play_circle_outline">Introduction</ui-button>
    <ui-button class="big-round-corner-button" v-shadow.transition="[1, 4]" unelevated icon="arrow_forward" v-on:click="tabNewPath('https://play.google.com/store/apps/details?id=com.JustZht.Skyline')">Get it on Google Play</ui-button>
    <div style="margin: 1rem 0;">
    </div>
    <ui-card outlined>
    <ui-card-content style="padding: 0;" v-ripple>
      <div style="padding: 1rem;">
        <span :class="$tt('button')">WHAT IS SKYLINE?</span>
        <p :class="$tt('body1')">Skyline is a live wallpaper for your Android devices. It loads 3D terrain directly on your home screen, with swipe and unlock animations.</p>
      </div>
      <img style="width: 100%" v-bind:src="require('../../public/img/banner.jpg')">
    </ui-card-content>
  </ui-card>
    <br>
    <ui-card outlined>
      <div style="padding: 0.5rem 1rem;"><span :class="$tt('button')">APP FEATURES</span></div>
      <ui-list-divider/>
      <ui-list v-bind:type="2" avatar twoLine v-bind:nonInteractive="true">
        <ui-item>
          <ui-item-first-content>
            <ui-icon>3d_rotation</ui-icon>
          </ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>3D terrain from various map provider</ui-item-text1>
            <ui-item-text2>Including Mapbox, ArcGis, Bing, Google Maps and Here</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

        <ui-item>
          <ui-item-first-content>
            <ui-icon>touch_app</ui-icon>
          </ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>Scene shift & Launcher swipe animations</ui-item-text1>
            <ui-item-text2>Just like what live wallpaper pre-installed in Pixel phones will do.</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

        <ui-item>
          <ui-item-first-content>
            <ui-icon>gps_fixed</ui-icon>
          </ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>Location tracking mode</ui-item-text1>
            <ui-item-text2>Automatic updates in the background</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

        <ui-item>
          <ui-item-first-content>
            <ui-icon>local_library</ui-icon>
          </ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>Skyline presents</ui-item-text1>
            <ui-item-text2>A library of gorgeous locations </ui-item-text2>
          </ui-item-text-content>
        </ui-item>

      </ui-list>
      <ui-card-actions fullBleed>
        <ui-button v-on:click="pushNewPath('changelog')">
          Read the changelog
          <template #after>
            <ui-icon>arrow_forward</ui-icon>
          </template>
        </ui-button>
      </ui-card-actions>
    </ui-card>
    <br>
    <ui-card outlined>
      <ui-card-content style="padding: 1rem 1rem 0;" v-ripple>
        <div><span :class="$tt('button')">SCREENSHOTS</span></div>
      </ui-card-content>
      <ui-card-actions fullBleed>
        <ui-button actionButton v-on:click="pushNewPath('presents')">
          View more at presents library
          <template #after>
            <ui-icon>arrow_forward</ui-icon>
          </template>
        </ui-button>
      </ui-card-actions>
    </ui-card>
    <br>
    <ui-card outlined>
      <div style="padding: 0.5rem 1rem" ><span :class="$tt('button')">FEATURED BY TECH MEDIAS</span></div>
      <ui-list-divider/>
      <ui-list v-bind:type="2" avatar twoLine>
        <ui-item v-on:click="tabNewPath('https://www.theverge.com/circuitbreaker/2018/1/20/16909558/skyline-android-app-wallpaper-live-map-location')">
          <ui-item-first-content><img v-bind:src="require('../../public/img/theverge.png')"></ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>The Verge</ui-item-text1>
            <ui-item-text2>This Android app will turn your wallpaper into a live map of your location</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

        <ui-item v-on:click="tabNewPath('https://lifehacker.com/this-android-app-turns-any-location-into-an-interactive-1822205429')">
          <ui-item-first-content><img v-bind:src="require('../../public/img/lifehacker.png')"></ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>Lifehacker</ui-item-text1>
            <ui-item-text2>Turn Any Location Into an Interactive Google Earth-Style Wallpaper With This Android App</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

        <ui-item v-on:click="tabNewPath('https://www.androidauthority.com/skyline-pixel-2-style-live-wallpaper-831213/')">
          <ui-item-first-content><img v-bind:src="require('../../public/img/aa.jpeg')"></ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>Android Authority</ui-item-text1>
            <ui-item-text2>Here’s how to set any location as a Pixel 2-style live wallpaper</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

        <ui-item v-on:click="tabNewPath('https://thenextweb.com/apps/2018/01/22/get-a-birds-eye-view-of-your-location-on-your-android-home-screen-with-this-live-wallpaper/')">
          <ui-item-first-content><img v-bind:src="require('../../public/img/tnw.jpg')"></ui-item-first-content>
          <ui-item-text-content>
            <ui-item-text1>The Next Web</ui-item-text1>
            <ui-item-text2>This Android live wallpaper brings you a bird’s eye view of your location</ui-item-text2>
          </ui-item-text-content>
        </ui-item>

      </ui-list>
      <ui-card-actions fullBleed>
        <ui-button v-bind:disabled="true" actionButton>
          Download PressKit (Coming Soon)
          <template #after>
            <ui-icon>arrow_forward</ui-icon>
          </template>
        </ui-button>
      </ui-card-actions>
    </ui-card>

    <ui-dialog id="landing_video_player_dialog" v-bind:closable="true" v-bind:maskClosable="true" v-model="landingVideoDialogOpen">
      <ui-dialog-title>Introduction to Skyline</ui-dialog-title>
      <ui-dialog-content style="display: inline-flex;padding: 0;margin: 0;">
        <video-player ref="landingVideo" v-bind:options="this.skylineVideoOptions" v-bind:style="{width: landingVideoPlayerWidth}" class="vjs-16-9">
        </video-player>
      </ui-dialog-content>
      <ui-dialog-actions>
        <ui-button v-on:click="closeLandingVideoDialog" class="big-round-corner-button">Done</ui-button>
      </ui-dialog-actions>
    </ui-dialog>
  </div>
</template>

<script>
import UiButton from 'balm-ui/src/scripts/components/button/button'
require('videojs-youtube')
export default {
  name: 'landing',
  components: { UiButton },
  methods:
      {
        tabNewPath: function (path) {
          window.open(path, '_blank')
        },
        pushNewPath: function (path) {
          this.$router.push({ path: path })
        },
        openLandingVideoDialog: function () {
          this.landingVideoDialogOpen = true
        },
        closeLandingVideoDialog: function () {
          this.landingVideoDialogOpen = false
        }
      },
  computed: {
    landingVideoPlayer: function () {
      return this.$refs.landingVideo.player
    },
    landingVideoPlayerWidth: function () {
      if (window.innerWidth * 0.9 < 1280) {
        return window.innerWidth * 0.9 + 'px'
      } else {
        return 1280 + 'px'
      }
    }
  },
  watch: {
    landingVideoDialogOpen: {
      handler: function (val, oldVal) {
        console.log(this.$refs.landingVideo)
        console.log(this.$refs.landingVideo.player)
        if (val) {
          this.$refs.landingVideo.player.play()
        } else {
          this.$refs.landingVideo.player.pause()
          this.$refs.landingVideo.player.currentTime(0)
        }
      }
    }
  },
  data () {
    return {
      skylineVideoOptions: {
        fluid: true,
        sources: [{
          type: 'video/youtube',
          src: 'https://www.youtube.com/watch?v=v6bcGHqtQL0'
        }],
        techOrder: ['youtube'],
        autoplay: false,
        controls: false,
        youtube: {
          ytControls: 2
        }
      },
      landingVideoDialogOpen: false
    }
  }
}
</script>

<style scoped>
</style>
